export default function initBannerActions() {

	jQuery(document).ready(function(){
		const hideBanner = getCookie("hide_banner");

		if (typeof hideBanner == "undefined" || hideBanner == null){
			jQuery('.banner').addClass('active');
		}
	});

	jQuery('.banner .banner-close').on('click', function(e){
		e.preventDefault();
		jQuery(this).parents('.banner').removeClass('active');
		setCookie('hide_banner', '1', 7);
	});

	function setCookie(name, value, daysToExpire) {
    const date = new Date();
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + "; " + expires + " path=/";
	}

	function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.indexOf(name + "=") === 0) {
            return cookie.substring(name.length + 1, cookie.length);
        }
    }
    return null;
	}
}
